import React from 'react';
import { BranchImage, RetailImage } from 'store/space/type';
import styled from 'styled-components';

// Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper/core';

SwiperCore.use([Pagination, Navigation]);

const Container = styled.div`
  .mySwiper {
    margin-top: 1vw;
    --swiper-theme-color: #ede6db !important;

    .swiper-wrapper {
      .swiper-slide > img {
        object-fit: contain;
        width: 100%;
        max-height: 50vh;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }
`;

interface IProps {
  images: Array<string> | Array<BranchImage> | Array<RetailImage>;
}

const ImageSlider: React.FC<IProps> = ({ images }: IProps) => {
  return (
    <Container>
      <Swiper
        pagination={{ clickable: true }}
        navigation
        spaceBetween={30}
        loop
        className="mySwiper"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img src={image.image} alt="" />
          </SwiperSlide>
        ))}
      </Swiper>
    </Container>
  );
};

export default ImageSlider;
